import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";

export const MergeVideo = () => {
    const [files, setFiles] = useState([]);
    const [isMerging, setIsMerging] = useState(false);

    const onDrop = (acceptedFiles) => {
        // Filter out duplicates based on file name
        const newFiles = acceptedFiles.filter(
            (file) => !files.some((existingFile) => existingFile.name === file.name)
        );
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const handleFileUpload = (event) => {
        const uploadedFiles = Array.from(event.target.files);
        // Filter out duplicates based on file name
        const newFiles = uploadedFiles.filter(
            (file) => !files.some((existingFile) => existingFile.name === file.name)
        );
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    const handleAddMoreVideos = () => {
        document.getElementById("videoInput").click(); // Trigger the file input click
    };

    const mergeVideos = async () => {
        if (files.length < 2) {
            alert("Please upload at least two videos to merge.");
            return;
        }

        const formData = new FormData();
        files.forEach((file) => {
            formData.append("videos", file);
        });

        try {
            setIsMerging(true);
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/merge-videos`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                responseType: "blob",
            });

            // Download the merged video
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "merged_video.mp4");
            document.body.appendChild(link);
            link.click();
            link.remove();
            
        } catch (error) {
            console.error("Error merging videos:", error);
            alert("Failed to merge videos.");
        } finally {
            setIsMerging(false);
        }
    };

    return (
        <div style={{ textAlign: "center", padding: "20px" }}>
            <h1>Video Editor - Merge Video</h1>
            <div
                style={{
                    border: "2px dashed #cccccc",
                    padding: "20px",
                    cursor: "pointer",
                    marginBottom: "20px",
                    position: "relative",
                }}
            >
                <h5>Drag and Drop Videos Here or Click to Upload</h5>

                {/* React Dropzone for drag-and-drop */}
                <div {...useDropzone({ onDrop })} style={{ width: "100%", height: "100%" }}>
                    {files.length > 0 && (
                        <ul>
                            {files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* File input for selecting files */}
                <input
                    id="videoInput"
                    type="file"
                    accept="video/*"
                    multiple
                    onChange={handleFileUpload}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0, // Hide the file input, making it trigger on click inside the div
                        cursor: "pointer",
                    }}
                />
            </div>

            {files.length >= 1 && (
                <button onClick={handleAddMoreVideos}>Add More Videos</button>
            )}

            <button onClick={mergeVideos} disabled={isMerging}>
                {isMerging ? "Merging..." : "Merge Videos"}
            </button>
        </div>
    );
}

